// extracted by mini-css-extract-plugin
export default {"wrap":"ShippingInfoAddModal_wrap__Fe59n","pure":"ShippingInfoAddModal_pure__G+gtq","button":"ShippingInfoAddModal_button__9SvUi"};